import { TState } from 'store/store'

export const getPLayerId = (state: TState) => state.playQueue.playerId
export const getPlayQueue = (state: TState) => state.playQueue.queue
export const getIsSocketConnected = (state: TState) => state.playQueue.isSocketConnected
